import omit from 'lodash/omit'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

export interface ISavedLanesFilters
  extends Omit<
    BookableShipmentSavedSearch,
    | 'createdAt'
    | 'sourceType'
    | 'totalResultCount'
    | 'unviewedResultCount'
    | 'hasNotificationsEnabled'
    | 'motorCarrier'
    | 'motorCarrierId'
    | 'rate'
    | 'rateType'
    | 'updatedAt'
    | 'loadedMilesMax'
    | 'loadedMilesMin'
    | 'dropTrailer'
    | 'subscriptionCreatedById'
    | 'id'
  > {}

export const getSavedLaneBookingFilters = (
  savedLane: BookableShipmentSavedSearch
): ISavedLanesFilters => {
  const filters: ISavedLanesFilters = {
    ...omit(savedLane, [
      'createdAt',
      'sourceType',
      'totalResultCount',
      'unviewedResultCount',
      'hasNotificationsEnabled',
      'motorCarrier',
      'motorCarrierId',
      'rate',
      'rateType',
      'updatedAt',
      'loadedMilesMax',
      'loadedMilesMin',
      'dropTrailer',
      'subscriptionCreatedById',
      'id',
    ]),
  }
  return filters
}
